import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import {
  catchError,
  finalize,
  firstValueFrom,
  forkJoin,
  map,
  Observable,
  of,
  Subscription,
  switchMap,
  tap,
  throwError,
} from 'rxjs';
import { CfgQuestionarioComponent } from 'src/app/components/cfg-questionario/cfg-questionario.component';
import {
  InclusioneModuliComponent,
  ModuliInclusi,
} from 'src/app/components/inclusione-moduli/inclusione-moduli.component';
import {
  Filters,
  FnCaricamentoDati,
  FnCaricamentoStyle,
  SortBy,
} from 'src/app/components/lista-tabellare/classes/lista-tabellare-data-source';
import {
  BottoniListaEvent,
  Colonna,
  Filtri,
  ListaTabellareComponent,
} from 'src/app/components/lista-tabellare/lista-tabellare.component';
import { DialogAssociaFiguraAziendaleComponent } from 'src/app/components/selezione-elementi-questionario/dialog/dialog-associa-figura-aziendale/dialog-associa-figura-aziendale.component';
import { SelezioneObiettiviPianoComponent } from 'src/app/components/selezione-elementi-questionario/metodi-selezione/selezione-obiettivi-piano/selezione-obiettivi-piano.component';
import { SpinnerOverlayComponent } from 'src/app/components/spinner-overlay/spinner-overlay.component';
import { DATA_SERVICE } from 'src/app/components/totali-cruscotto/data-service.token';
import { TotaliCruscottoComponent } from 'src/app/components/totali-cruscotto/totali-cruscotto.component';
import { DialogCreaTemplateMailComponent } from 'src/app/page/analisi-materialita/materialita/dialog/dialog-crea-template-mail/dialog-crea-template-mail.component';
import { DialogCreaCfgModelliSviluppoPianoComponent } from 'src/app/page/configurazioni/cfg-modelli-sviluppo-piano/dialog-crea-cfg-modelli-sviluppo-piano/dialog-crea-cfg-modelli-sviluppo-piano.component';
import { DialogCreaObiettivoAziendaliComponent } from 'src/app/page/configurazioni/cfg-obiettivi-aziendali/dialog/dialog-crea-obiettivo-aziendali/dialog-crea-obiettivo-aziendali.component';
import { DialogAssegnazioniComponent } from 'src/app/page/sintesi-sostenibilita/dialog/dialog-assegnazioni/dialog-assegnazioni.component';
import { DialogCompilazioneFigureComponent } from 'src/app/page/sintesi-sostenibilita/dialog/dialog-compilazione-figure/dialog-compilazione-figure.component';
import { AutovalutazioniService } from 'src/app/services/autovalutazioni/autovalutazioni.service';
import { AziendaService } from 'src/app/services/azienda/azienda.service';
import { BilancioService } from 'src/app/services/bilancio/bilancio.service';
import { MaterialitaService } from 'src/app/services/materialita/materialita.service';
import { PianoService, PianoSostenibilita } from 'src/app/services/piano/piano.service';
import { PolicyService } from 'src/app/services/policy/policy.service';
import { Settore, SettoriService, SottoSettore } from 'src/app/services/settori/settori.service';
import { ElementiCruscotto, SintesiService } from 'src/app/services/sintesi/sintesi.service';
import { UtenteService } from 'src/app/services/utente/utente.service';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { DialogAssociaTargetObiettiviComponent } from '../dialog-associa-target-obiettivi/dialog-associa-target-obiettivi.component';

@Component({
  selector: 'app-dialog-crea-piano-sostenibilita',
  templateUrl: './dialog-crea-piano-sostenibilita.component.html',
  styleUrls: ['./dialog-crea-piano-sostenibilita.component.scss'],
  standalone: false,
  providers: [{ provide: DATA_SERVICE, useClass: PianoService }],
})
export class DialogCreaPianoSostenibilitaComponent implements OnInit, AfterViewInit {
  @ViewChild('stepper') stepper!: MatStepper;
  @ViewChild('btnAvanti') btnAvanti!: MatButton;
  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;
  @ViewChild(CfgQuestionarioComponent) componenteSurvey!: CfgQuestionarioComponent;
  @ViewChild('tabellaTarget') tabellaTarget!: ListaTabellareComponent;
  @ViewChild('tabellaCruscotto') tabellaCruscotto!: ListaTabellareComponent;
  @ViewChild(SelezioneObiettiviPianoComponent)
  componenteSelObiettiviPiano!: SelezioneObiettiviPianoComponent;
  @ViewChild(InclusioneModuliComponent) inclusioneModuli!: InclusioneModuliComponent;
  @ViewChild('totaliCruscotto') cmpTotaliCruscotto!: TotaliCruscottoComponent;

  public isPermessoInvioMail: boolean = this.utenteService.isPermessoAttivo('INVIO_MAIL');
  public isPermessoSoloRead: boolean = false;
  public mappaAnnoSettore: { [anno: string]: { [settore: string]: boolean } } = {};
  public objQuestionarioObiettivi = [];
  public arrayAnni: string[] = [];
  public settoriAzienda: Settore[] = [];
  public guidaDescrizione: string | undefined = undefined;
  public mostraDescrizione: boolean = false;
  public arraySottoSettori: SottoSettore[] = [];
  public settoreGenerale: Settore | undefined = undefined;
  public mostraBottoneAssegnazioni: boolean = false;
  public idQuestionario: string | undefined = undefined;

  private _subValueChangeSettore: Subscription | undefined = undefined;
  private _subValueChangeTipoSettore: Subscription | undefined = undefined;
  private _piano: any = {};

  public isTargetNonCompletto: boolean = false;

  public objDocumento: any;

  private msgControlloTarget: string = '';

  get isMaterialitaSelezionata(): boolean {
    return !!this.inclusioneModuli?.formInclusioneModuli.get('idMaterialita')?.value;
  }

  public idModuliInclusi: ModuliInclusi | undefined;

  get piano() {
    return this._piano;
  }

  public formPianoSostenibilita = new FormGroup({
    id: new FormControl<string | undefined>(undefined, {
      nonNullable: true,
      validators: [],
    }),

    idAzienda: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required],
    }),

    anno: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required],
    }),

    tipoSettore: new FormControl<'GENERALE' | 'SPECIFICO' | undefined>(undefined, {
      nonNullable: true,
      validators: [Validators.required],
    }),

    settori: new FormControl<Settore | undefined>(undefined, {
      nonNullable: true,
      validators: [Validators.required],
    }),

    sottoSettori: new FormControl<SottoSettore[]>([], {
      nonNullable: true,
    }),

    tipo: new FormControl<string>('PIANO', {
      nonNullable: true,
      validators: [],
    }),
  });

  public colonneTarget: { [key: string]: Colonna } = {
    ambito: {
      title: 'Ambito',
      value: 'titoloAmbito',
      sortable: true,
    },
    tematica: {
      title: 'Tematica',
      value: 'titoloTematica',
      sortable: true,
    },
    obiettiviSelezionati: {
      title: 'Obiettivi Selezionati',
      value: 'titolo',
      sortable: true,
    },
    idTargetQualitativi: {
      title: 'Target Qualitativi',
      value: (record: any) => record?.idTargetQualitativi.length,
      sortable: true,
    },
    idTargetQuantitativi: {
      title: 'Target Quantitativi',
      value: (record: any) => record?.idTargetQuantitativi.length,
      sortable: true,
    },
    aggiungiTarget: {
      type: 'button',
      buttonIcon:
        this.isPermessoSoloRead || this.isPubblicato() || this.isArchiviato()
          ? 'visibility'
          : 'add',
      title:
        this.isPermessoSoloRead || this.isPubblicato() || this.isArchiviato()
          ? 'Visualizza Target'
          : 'Aggiungi Target',
      buttonId: 'aggiungiTarget',
      buttonMostraSempre: true,
    },
  };

  public filtriCruscotto: Filtri[] = [
    {
      titolo: 'Figure Aziendali',
      forControlName: 'figureAziendali',
      input: 'text',
    },
    {
      titolo: 'Nome',
      forControlName: 'nome',
      input: 'text',
    },
    {
      titolo: 'Cognome',
      forControlName: 'cognome',
      input: 'text',
    },
    {
      titolo: 'Email',
      forControlName: 'email',
      input: 'text',
    },
  ];

  public colonneCruscotto: { [key: string]: Colonna } = {
    stakeholder: {
      title: 'Figure Aziendali',
      value: 'figura',
    },
    tipologia: {
      title: 'Nome',
      value: 'nome',
    },
    email: {
      title: 'Email',
      value: 'email',
    },
    stato: {
      title: 'Stato',
      value: (record: any) => {
        if (record?.stato === 'ROSSO') {
          // non compilato
          return '<div style="display: flex;justify-content: center;align-items:center;background-color:#cf5b61;width:25px;text-align: center;border-radius: 15px;height:25px"></div>';
        } else if (record?.stato === 'GIALLO') {
          // ha inviato la mail ma non è stato compilato (valore solo per gli stakeholder con modalita compilazione "INVIAMAIL")
          return '<div style="display: flex;justify-content: center;align-items:center;background-color:#c7a045;width:25px;text-align: center;border-radius: 15px;height:25px"></div>';
        } else if (record?.stato === 'VERDE') {
          // compilato
          return '<div style="display: flex;justify-content: center;align-items:center;background-color:#729373;width:25px;text-align: center;border-radius: 15px;height:25px"></div>';
        } else {
          return '';
        }
      },
    },
    history: {
      type: 'button',
      buttonIcon: this.isPermessoSoloReadFunx() ? 'visibility' : 'history_edu',
      title: this.isPermessoSoloReadFunx() ? 'Visualizza' : 'Compila',
      buttonId: 'compila',
      buttonMostraSempre: true,
      sortable: false,
    },

    modifica: {
      type: 'button',
      buttonIcon: 'person_edit',
      title: 'Modifica',
      buttonId: 'modifica',
      nascondiButton: (record) => record?.stato === 'VERDE' || this.isPermessoSoloReadFunx(),
      buttonMostraSempre: true,
    },
  };
  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<DialogCreaPianoSostenibilitaComponent>,
    private readonly materialitaService: MaterialitaService,
    private readonly utilityService: UtilityService,
    private readonly aziendaService: AziendaService,
    private readonly settoriService: SettoriService,
    private readonly sintesiService: SintesiService,
    private readonly bilancioService: BilancioService,
    private readonly policyService: PolicyService,
    private readonly pianoService: PianoService,
    private readonly autovalutazioniService: AutovalutazioniService,
    private readonly utenteService: UtenteService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      piano: PianoSostenibilita;
    },
  ) {
    this.idModuliInclusi = {
      idMaterialita: data.piano?.idMaterialita,
      idBilancioSostenibilita: data.piano?.idBilancioSostenibilita,
      idSintesiSostenibilita: data.piano?.idSintesiSostenibilita,
      idAutovalutazioneCompilata: data.piano?.idAutovalutazioneCompilata,
      idPolicySostenibilita: data.piano?.idPolicySostenibilita,
    };
  }

  ngOnInit(): void {
    const annoCorrente = new Date().getFullYear();

    // Aggiungi gli anni indietro di 5 anni e in avanti di 1 anno all'array
    for (let i = annoCorrente - 5; i <= annoCorrente + 1; i++) {
      this.arrayAnni.push(i.toString());
    }

    // Aggiungo l'anno di un modulo precedente agli anni calcolati.
    // Se ho creato un modulo di ques'anno allora tramite questa gestione l'anno prossimo riuscirò a viusalizzarlo
    if (this.data.piano) {
      const { anno } = this.data.piano;
      if (anno && !this.arrayAnni.includes(anno)) {
        this.arrayAnni.push(anno);
      }
    }
  }

  ngAfterViewInit(): void {
    this.aziendaService.azienda.then((azienda) => {
      if (azienda) {
        this.formPianoSostenibilita.get('idAzienda')?.setValue(azienda.id);
      }
    });

    setTimeout(() => {
      this._init();
    }, 0);

    this.gestioneStepperPiano();

    this.isPermessoSoloRead = this.isPermessoSoloReadFunx();

    if (this.isPermessoSoloRead) {
      this.formPianoSostenibilita.disable();
    }
  }

  isPermessoSoloReadFunx() {
    const isEdit = this.utenteService.isPermessoAttivo('EDIT_PIANO');
    const isCreate = this.utenteService.isPermessoAttivo('CREATE_PIANO');
    return (!isEdit && !isCreate) || this.isArchiviato();
  }

  private async _init() {
    this.spinnerOver.show();

    await this._caricaSettori();

    this._valueChangeSettori();

    if (this.data.piano) {
      await this._setDatiPiano(this.data.piano);
    } else if (this.settoriAzienda?.length) {
      // Preselezione settore
      this.formPianoSostenibilita.get('tipoSettore')?.setValue('SPECIFICO');
      this.formPianoSostenibilita.get('settori')?.setValue(this.settoriAzienda[0]);
    } else {
      this.formPianoSostenibilita.get('tipoSettore')?.setValue('GENERALE');
    }

    this._caricaStepTematiche().subscribe();

    this.spinnerOver.hide();
  }

  ngOnDestroy(): void {
    this._subValueChangeSettore?.unsubscribe();
    this._subValueChangeTipoSettore?.unsubscribe();
  }

  /**
   * Gestione cambiamento dei settori sottosetorri e tipo settore
   */
  private _valueChangeSettori() {
    if (!this.data.piano) {
      this._subValueChangeSettore = this.formPianoSostenibilita
        .get('settori')!
        .valueChanges.subscribe((value) => {
          if (value) {
            this.arraySottoSettori =
              this.settoriAzienda.find((sett) => sett.id === value.id)?.sottoSettori || [];
          }

          this._updateSottoSettoriSelezionati();
        });

      this._subValueChangeTipoSettore = this.formPianoSostenibilita
        .get('tipoSettore')
        ?.valueChanges.subscribe((value) => {
          if (value === 'GENERALE') {
            this.formPianoSostenibilita.get('settori')?.setValue(this.settoreGenerale);
          } else if (value === 'SPECIFICO') {
            this.formPianoSostenibilita
              .get('settori')
              ?.setValue(this.settoriAzienda?.length ? this.settoriAzienda[0] : undefined);
          }
        });
    }
  }

  /**
   * Setta Dati iniziali del piano
   * @param piano
   */
  private async _setDatiPiano(piano: PianoSostenibilita) {
    let settoreSel: Settore | undefined = piano.settori?.length ? piano.settori[0] : undefined;

    this._setValoriForm(piano);

    if (settoreSel) {
      this._setValoreSettore(settoreSel);
    }

    if (this.formPianoSostenibilita.get('id')?.value) {
      this.formPianoSostenibilita.disable();
    }
  }

  private _setValoriForm(piano: PianoSostenibilita) {
    Object.keys(piano).forEach((value) => {
      if (value === 'settori') {
        // Settore si imposta per ultimo, per non far scattare il change quando non è ancora settato l'array dei sottosettori
        this.formPianoSostenibilita.get(value)?.setValue((piano as any)[value][0]);
      } else {
        this.formPianoSostenibilita.get(value)?.setValue((piano as any)[value]);
      }
    });
  }

  private _setValoreSettore(settoreSel: Settore) {
    if (!this.settoriAzienda.find((set) => set.id === settoreSel.id)) {
      // Il settore del bilancio non è negli array dei settori azienda.
      // Potrebbe essere stato tolto a posteriori, dopo la creazione del piano.
      // Per non lasciare il campo vuoto, si setta nell'array il settore che viene dal piano.
      this.settoriAzienda = [settoreSel];
    }
    this.formPianoSostenibilita.get('settori')?.setValue(settoreSel);
  }

  /**
   * Bottone indietro
   * @returns step precedente
   */
  public indietro() {
    switch (this.stepper.selectedIndex) {
      case 0:
        return true;
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
      case 8:
      case 9:
        this.stepper.previous();
        return true;
      default:
        return null;
    }
  }

  /**
   * Bottone avanti che salva i dati sullo step attuale
   * @returns metodo in base allo step attuale
   */
  public async avanti() {
    this.spinnerOver.show();

    let esito = false;

    switch (this.stepper.selectedIndex) {
      case 0:
        esito = await this._salvaStepPiano();
        break;
      case 1:
        esito = await this._salvaStepTematiche();
        break;
      case 2:
        esito = await this._salvaStepObiettivi();
        break;
      case 3:
        esito = this._ctrTarget();
        break;
      case 4:
        esito = true;
        break;
      case 5:
        esito = await this.stampa();
        break;
      default:
        break;
    }

    this.spinnerOver.hide();

    return esito;
  }

  public async avantiHTML() {
    if (this.isPermessoSoloRead || (await this.avanti())) {
      return this.stepper.next();
    }
  }

  /**
   * Viene disabilitato per non spammare il bottone avanti mentre stanno caricando i dati
   */
  disabilitaBottoneAvanti() {
    setTimeout(() => {
      this.btnAvanti.disabled = true;
    }, 0);
  }

  /* Mi carica i dati nello step selezionato */
  cambioStep(event: StepperSelectionEvent) {
    this.mostraBottoneAssegnazioni = false;

    switch (event.selectedIndex) {
      case 0:
        return;

      case 1:
        this.disabilitaBottoneAvanti();
        this._caricaStepTematiche().subscribe();
        break;

      case 2:
        this.mostraBottoneAssegnazioni = true;
        this.disabilitaBottoneAvanti();
        return this._getObiettiviPiano();

      case 3:
        this.spinnerOver.hide();
        return this.tabellaTarget.caricaDati();

      case 4:
        this.spinnerOver.show();
        return this.caricaStepCruscotto();

      case 5:
        this.spinnerOver.show();
        return this.caricaDocumento();

      default:
        return;
    }
  }

  compareById(elemento1: any, elemento2: any): boolean {
    return elemento1?.id === elemento2?.id; // Sostituisci "id" con la proprietà univoca dei settori
  }

  /**
   * Gestione caricamento settori e sotto settori
   */
  private async _caricaSettori() {
    this.spinnerOver.show();
    try {
      const risp = await firstValueFrom(
        forkJoin({
          generale: this.settoriService.getSettoreGenerale().pipe(
            catchError((err) => {
              console.error('ERRORE GET SETTORE GENERALE : ', err);
              // Errore recupero settore generale, potrebbe non esistere. Si torna undefined
              return of(undefined);
            }),
          ),
          specifici: this.aziendaService.getSettoriAzienda(),
          pianiCreate: this.pianoService.getPianoSostenibilita(0, 1000, '', []).pipe(
            catchError((err) => {
              console.error('ERRORE GET PIANI CREATE : ', err);
              return of(undefined);
            }),
          ),
        }),
      );

      this.settoriAzienda = risp?.specifici || [];
      this.settoreGenerale = risp?.generale;
      const pianiCreati = risp.pianiCreate.content ?? [];

      if (pianiCreati) {
        this.mappaAnnoSettore = this.settoriService.getModuliDaCreare(pianiCreati);
      }
      if (!this.settoriAzienda?.length && !this.settoreGenerale) {
        console.error('NESSUN SETTORE DISPONIBILE, IMPOSSIBILE PROSEGUIRE');
      }

      this.arraySottoSettori =
        this.settoriAzienda.find(
          (sett) => sett.id === this.formPianoSostenibilita.get('settori')?.value?.id,
        )?.sottoSettori || [];

      this.spinnerOver.hide();
    } catch (error) {
      console.error(error);

      this.spinnerOver.hide();

      this.utilityService.openDialog({
        titolo: 'Attenzione',
        descrizione: 'Errore nel recupero dei settori',
        bottoni: [{ nome_btn: 'Ok' }],
      });

      this.dialogRef.close();
    }
  }

  private _updateSottoSettoriSelezionati() {
    const sottoSettoriSel = this.formPianoSostenibilita.get('sottoSettori')?.value || [];

    const sottoSettoriaggiornati = sottoSettoriSel.filter((sottoSettSel) => {
      return (
        this.arraySottoSettori &&
        sottoSettSel.id &&
        !!this.arraySottoSettori.find((sottoSett) => {
          return sottoSett.id === sottoSettSel.id;
        })
      );
    });

    this.formPianoSostenibilita.get('sottoSettori')?.setValue(sottoSettoriaggiornati || []);
  }

  /**
   * Metodo che mi fa la get del questionario della Piano
   * @param id id Piano
   * @returns
   */
  private _getQuestionarioPiano(id: string) {
    return this.pianoService
      .getQuestionarioPiano(id)
      .pipe(
        catchError((err) => {
          console.error(err);
          if (err.status === 404) {
            return of(false);
          } else {
            return throwError(() => err);
          }
        }),
      )
      .pipe(
        map((piano) => {
          if (piano) {
            this._piano = piano;
          }
          return piano;
        }),
      );
  }

  public bottoniListaClickCruscotto(event: BottoniListaEvent) {
    switch (event.id) {
      case 'modifica':
        this.modificaFigura(event.data);
        break;
      case 'compila':
        this.eleCompilazioneFigura(
          event.data.elementi,
          event.data.nome,
          event.data.figura,
          event.data.id,
        );

        break;
      case 'azione':
        if (event.data) {
          if (event.data.ultimoInvio) {
            this._inviaNotificaSingola(event.data);
          } else {
            this._inviaMailSingola(event.data);
          }
        }
        break;
      default:
        console.warn('ATTENZIONE: bottone ' + event.id + ' non riconosciuto');
    }
  }
  /**
   * Metodo che mi invia una notifica singola
   * @param cruscotto
   * @returns
   */
  private async _inviaNotificaSingola(cruscotto: any) {
    const idPianoSostenibilita = this.formPianoSostenibilita.get('id')?.value;

    if (idPianoSostenibilita) {
      const testiMail = await firstValueFrom(
        this.pianoService.getTemplateMail(idPianoSostenibilita),
      );

      if (!testiMail?.mailInvio) {
        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: "Prima di fare l'invio compilare i Testi Mail",
          bottoni: [{ nome_btn: 'Ok' }],
        });
        return;
      }

      const dialog = this.utilityService.openDialog({
        titolo: 'Confermare invio?',
        descrizione: 'Sarà inviata una notifica alla figura selezionata',
        bottoni: [
          {
            nome_btn: 'No',
            id_btn: 'N',
          },
          {
            nome_btn: 'Si',
            id_btn: 'S',
          },
        ],
      });

      const valDialog = await firstValueFrom(dialog.beforeClosed());
      if (valDialog === 'N') {
        return;
      }

      try {
        this.spinnerOver.show();

        await firstValueFrom(this.pianoService.inviaNotifica(idPianoSostenibilita, cruscotto.id));
        await firstValueFrom(this._getQuestionarioPiano(idPianoSostenibilita));

        this.tabellaCruscotto.caricaDati();

        this.utilityService.openSnackBar('Notifica inviata ', '', {
          duration: 2000,
          panelClass: ['success-snackbar'],
        });
        this.spinnerOver.hide();
      } catch (error: any) {
        console.error(error);
        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: error?.error?.message || 'Errore invio notifica',
          bottoni: [{ nome_btn: 'Ok' }],
        });
        this.spinnerOver.hide();
      }
    }
  }
  async notificaTutti() {
    const idPianoSostenibilita = this.formPianoSostenibilita.get('id')?.value;

    if (idPianoSostenibilita) {
      const testiMail = await firstValueFrom(
        this.pianoService.getTemplateMail(idPianoSostenibilita),
      );

      if (!testiMail?.mailInvio) {
        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: "Prima di fare l'invio compilare i Testi Mail",
          bottoni: [{ nome_btn: 'Ok' }],
        });
        return;
      }

      const dialog = this.utilityService.openDialog({
        titolo: 'Confermare invio?',
        descrizione: 'Sarà inviata una notifica a tutte le figure che hanno ricevuto la mail',
        bottoni: [
          {
            nome_btn: 'No',
            id_btn: 'N',
          },
          {
            nome_btn: 'Si',
            id_btn: 'S',
          },
        ],
      });

      const valDialog = await firstValueFrom(dialog.beforeClosed());
      if (valDialog === 'N') {
        return;
      }

      try {
        this.spinnerOver.show();
        await firstValueFrom(this.pianoService.inviaNotificaMultiple(idPianoSostenibilita));
        await firstValueFrom(this._getQuestionarioPiano(idPianoSostenibilita));

        this.tabellaCruscotto.caricaDati();

        this.utilityService.openSnackBar('Notifica inviata ', '', {
          duration: 2000,
          panelClass: ['success-snackbar'],
        });
        this.spinnerOver.hide();
      } catch (error: any) {
        console.error(error);
        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: error?.error?.message || 'Errore invio notifiche',
          bottoni: [{ nome_btn: 'Ok' }],
        });
        this.spinnerOver.hide();
      }
    }
  }

  private async _inviaMailSingola(cruscotto: any) {
    const idPianoSostenibilita = this.formPianoSostenibilita.get('id')?.value;

    if (idPianoSostenibilita) {
      const testiMail = await firstValueFrom(
        this.pianoService.getTemplateMail(idPianoSostenibilita),
      );

      if (!testiMail?.mailInvio) {
        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: "Prima di fare l'invio compilare i Testi Mail",
          bottoni: [{ nome_btn: 'Ok' }],
        });
        return;
      }

      const dialog = this.utilityService.openDialog({
        titolo: 'Confermare invio?',
        descrizione: 'Invia mail ',
        bottoni: [
          {
            nome_btn: 'No',
            id_btn: 'N',
          },
          {
            nome_btn: 'Si',
            id_btn: 'S',
          },
        ],
      });

      const valDialog = await firstValueFrom(dialog.beforeClosed());
      if (valDialog === 'N') {
        return;
      }

      try {
        this.spinnerOver.show();
        await firstValueFrom(this.pianoService.inviaMail(idPianoSostenibilita, cruscotto.id));
        await firstValueFrom(this._getQuestionarioPiano(idPianoSostenibilita));
        this.tabellaCruscotto.caricaDati();

        this.utilityService.openSnackBar('Mail inviata ', '', {
          duration: 2000,
          panelClass: ['success-snackbar'],
        });
        this.spinnerOver.hide();
      } catch (error: any) {
        console.error(error);
        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: error?.error?.message || 'Errore invio mail',
          bottoni: [{ nome_btn: 'Ok' }],
        });
        this.spinnerOver.hide();
      }
    }
  }

  async inviaTutti() {
    const idPianoSostenibilita = this.formPianoSostenibilita.get('id')?.value;

    if (idPianoSostenibilita) {
      const testiMail = await firstValueFrom(
        this.pianoService.getTemplateMail(idPianoSostenibilita),
      );

      if (!testiMail?.mailInvio) {
        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: "Prima di fare l'invio compilare i Testi Mail",
          bottoni: [{ nome_btn: 'Ok' }],
        });
        return;
      }

      if (!this.isPubblicato() && !this.isArchiviato()) {
        const risultatoObservable = await this._pubblicazionePiano("con l'invio mail");
        if (risultatoObservable) {
          const risultato = await firstValueFrom(risultatoObservable);
          if (!risultato) {
            return;
          }
        }
        this.spinnerOver.hide();
      }

      try {
        this.spinnerOver.show();
        await firstValueFrom(this.pianoService.inviaMailMultiple(idPianoSostenibilita));
        await firstValueFrom(this._getQuestionarioPiano(idPianoSostenibilita));
        this.tabellaCruscotto.caricaDati();
        this.utilityService.openSnackBar('Mail inviata ', '', {
          duration: 2000,
          panelClass: ['success-snackbar'],
        });
        this.spinnerOver.hide();
      } catch (error: any) {
        console.error(error);
        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: error?.error?.message || 'Errore invio mail',
          bottoni: [{ nome_btn: 'Ok' }],
        });
        this.spinnerOver.hide();
      }
    }
  }

  /**
   * Modifica figura su cruscotto
   * @param dati
   */
  modificaFigura(dati: any) {
    const dialogAssociaFiguraAziendale = this.dialog.open(DialogAssociaFiguraAziendaleComponent, {
      data: {
        figura: { id: dati.id },
      },
      panelClass: 'dialog-container',
      disableClose: false,
      width: '50%',
      maxHeight: '95%',
      autoFocus: false,
    });

    dialogAssociaFiguraAziendale.afterClosed().subscribe((idFiguraNuova) => {
      const idFiguraPrecedente = dati?.id;

      const idPianoSostenibilita = this.formPianoSostenibilita.get('id')?.value;

      if (idPianoSostenibilita && idFiguraPrecedente && idFiguraNuova) {
        this.pianoService
          .putCambiaFigura(idPianoSostenibilita, idFiguraPrecedente, idFiguraNuova)
          .subscribe({
            next: () => {
              this.tabellaCruscotto.caricaDati();
            },
            error: (err) => {
              this.tabellaCruscotto.caricaDati();
              console.error(err);
            },
          });
      }
    });
  }

  template() {
    const idPianoSostenibilita = this.formPianoSostenibilita.get('id')?.value;

    if (idPianoSostenibilita) {
      const dialogCreaTemplateMail = this.dialog.open(DialogCreaTemplateMailComponent, {
        data: {
          idModulo: idPianoSostenibilita,
          tipoModulo: 'PIANO',
          isPermessoSoloRead: this.isPermessoSoloRead,
        },
        panelClass: 'dialog-container-scrollbar',
        disableClose: false,
        width: '95%',
        height: '95%',
        autoFocus: false,
      });

      dialogCreaTemplateMail.afterClosed().subscribe(() => {});
    }
  }

  private async _pubblicazionePiano(desc?: string): Promise<Observable<boolean> | undefined> {
    const idPianoSostenibilita = this.formPianoSostenibilita.get('id')?.value;
    let titolo: string = 'ATTENZIONE!';
    let descrizione: string = `
      <div>
        <p>
          <strong>Si prega di notare che questa operazione concluderà la definizione del Piano di Sostenibilità. </strong>
        </p>
        <ul>
          <li>L'operazione è definitiva e <strong>NON</strong> potrà essere annullata.</li>
          <li>Non sarà più possibile <strong>aggiungere</strong> o <strong>modificare</strong> gli obiettivi ed i target selezionati. </li>
          <li>Potrai completare le informazioni relative alla scheda “Documento” in qualsiasi momento.</li>
        </ul>
        <p><strong>Vuoi procedere ${desc ?? ''}?</strong></p>
      </div>
    `;

    const dialog = this.utilityService.openDialog({
      titolo: titolo,
      descrizione: descrizione,
      fontWeight: '500',
      bottoni: [
        { nome_btn: 'No', id_btn: 'N' },
        { nome_btn: 'Si', id_btn: 'S' },
      ],
    });

    const valDialog = await firstValueFrom(dialog.beforeClosed());
    if (valDialog === 'N') {
      return of(false);
    }

    // PUBBLICO IL BILANCIO E ASPETTO LA RISPOSTA
    this.spinnerOver.show();
    await firstValueFrom(this.pianoService.pubblicaPiano(idPianoSostenibilita!));
    return of(true);
  }

  /**
   * Get cruscotto filtrato per figura
   * @param idFigura
   * @param idPianoSostenibilita
   * @returns
   */
  getFiguraCruscotto(idFigura: string, idPianoSostenibilita: string) {
    return new Promise((resolve, reject) => {
      let filtroFiguraSelezionata: Filters = {
        values: [idFigura],
        operator: 'eq',
        chiave: 'id',
      };

      this.pianoService
        .getCruscotti(idPianoSostenibilita ?? '', 0, 1000, '', [filtroFiguraSelezionata])
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(new Error(err)),
        });
    });
  }

  /**
   *
   * @param elementiCruscotto
   * @param nome
   * @param figura
   */
  public async eleCompilazioneFigura(
    elementiCruscotto: ElementiCruscotto[],
    nome: string,
    figura: string,
    idFigura: string,
  ) {
    const idPianoSostenibilita = this.formPianoSostenibilita.get('id')?.value;

    if (idPianoSostenibilita) {
      if (!this.isPubblicato() && !this.isPermessoSoloRead) {
        /* --- Modifica richiesta: Se ci sono elementi precompilati lo posso sapere solamente se pubblico 
          il questionario, una volta pubblicato, il BE calcola le precompilazioni, mi rifaccio la get del cruscotto filtrato
          per idFigura selezionata e mi reperisco gli elementi aggiornati e precompilati. --- */

        const risultatoObservable = await this._pubblicazionePiano('alla compilazione');
        if (risultatoObservable) {
          const risultato = await firstValueFrom(risultatoObservable);
          if (!risultato) {
            return;
          }
          try {
            // CHIAMO LA FIGURA FILTRTA E ASPETTO RISPOSTA
            const figura: any = await this.getFiguraCruscotto(idFigura, idPianoSostenibilita);
            elementiCruscotto = figura?.content[0]?.elementi;
          } catch (err) {
            console.error(err);
          }
        }
        this.spinnerOver.hide();
      }

      const dialogCompilazioneFigure = this.dialog.open(DialogCompilazioneFigureComponent, {
        data: {
          elementiCruscotto,
          idPianoSostenibilita,
          nome,
          figura,
          isPermessoSoloRead: this.isPermessoSoloRead,
        },
        panelClass: 'dialog-container',
        disableClose: false,
        width: '75%',
        maxHeight: '95%',
        autoFocus: false,
      });

      dialogCompilazioneFigure
        .afterClosed()
        .pipe(
          switchMap(() => {
            this.spinnerOver.show();
            return this._getQuestionarioPiano(idPianoSostenibilita);
          }),
        )
        .subscribe(() => {
          this.tabellaCruscotto.caricaDati();
          this.cmpTotaliCruscotto.getTotaliCruscotto();
          this.spinnerOver.hide();
        });
    }
  }

  public bottoniListaClickTarget(event: BottoniListaEvent) {
    if (event.id === 'aggiungiTarget') {
      this._aggiungiTarget(event.data);
    } else {
      console.warn('ATTENZIONE: bottone ' + event.id + ' non riconosciuto');
    }
  }

  private _aggiungiTarget(dati: any) {
    const listaId = {
      idPianoSostenibilita: this.formPianoSostenibilita.get('id')?.value,
      idAmbito: dati.idAmbito,
      idTematica: dati.idTematica,
      idObiettivo: dati.id,
    };
    const dialogAssociaTargetObiettivi = this.dialog.open(DialogAssociaTargetObiettiviComponent, {
      data: {
        listaId: listaId,
        stato: this.piano?.stato,
        titoloObiettivo: dati?.titolo,
        desObiettivo: dati?.descrizione,
        isPermessoSoloRead: this.isPermessoSoloRead || this.isPubblicato(),
        settore: this.piano?.settori,
      },
      panelClass: 'dialog-container',
      disableClose: false,
      width: '95%',
      height: '95%',
      maxHeight: '99%',
      autoFocus: false,
    });

    dialogAssociaTargetObiettivi.afterClosed().subscribe(() => {
      this.tabellaTarget.caricaDati();
    });
  }

  assegnazioni() {
    const dialogAssegnazioniFigAzz = this.dialog.open(DialogAssegnazioniComponent, {
      data: {
        idContesto: this.formPianoSostenibilita.get('id')?.value,
        stato: this.piano?.stato,
        contesto: 'piano',
        isPermessoSoloRead: this.isPermessoSoloRead,
      },
      panelClass: 'dialog-container',
      disableClose: false,
      width: '75%',
      maxHeight: '95%',
      autoFocus: false,
    });

    dialogAssegnazioniFigAzz.afterClosed().subscribe(() => {
      if (this.isPubblicato() || this.isArchiviato()) {
        return;
      }
      this.tabellaTarget.caricaDati();
    });
  }

  //******************************* METODI CARICAMENTO PER cambioStep() *************************************/

  private _caricaStepTematiche() {
    const id = this.formPianoSostenibilita.get('id')?.value;

    const idSettore = (this.formPianoSostenibilita.get('settori')?.value as Settore).id;
    this.componenteSurvey.datiInizialiCfgQuestionario(idSettore);

    if (!id) {
      return of(false);
    }

    this.spinnerOver.show();

    return this._getQuestionarioPiano(id).pipe(
      map((piano) => {
        if (piano) {
          this._piano = piano;
        }
        this.btnAvanti.disabled = false;

        this.completaStep();

        return true;
      }),
      catchError((error) => {
        console.error(error);
        this.btnAvanti.disabled = false;

        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: 'Errore nel recupero della piano',
          bottoni: [{ nome_btn: 'Ok' }],
        });
        return of(false);
      }),
      finalize(() => {
        this.spinnerOver.hide();
      }),
    );
  }

  /**
   * Get ws Obiettivi piano
   * @returns
   */
  private async _getObiettiviPiano() {
    const id = this.formPianoSostenibilita.get('id')?.value;

    if (!id) {
      return false;
    }

    this.spinnerOver.show();
    return firstValueFrom(
      this.pianoService.getObiettiviPiano(id).pipe(
        map((esito) => {
          this.objQuestionarioObiettivi = esito;
          this.componenteSelObiettiviPiano.objQuestionario = esito;

          return true;
        }),
        catchError((err) => {
          console.error(err);
          this.utilityService.openDialog({
            titolo: 'Attenzione',
            descrizione: 'Errore nel recupero degli obiettivi',
            bottoni: [{ nome_btn: 'Ok' }],
          });

          return of(false);
        }),
        finalize(() => {
          this.spinnerOver.hide();
          this.btnAvanti.disabled = false;
        }),
      ),
    );
  }

  /*   private provaObj = {
      content: [
        {
          titolo: "obbiettivo titolo", idTargetQualitativi: [], idTargetQuantitativi: []
        }
      ]
    } */

  /* per Alert */
  public ctrAssegnazioniTarget(esito: any): void {
    this.isTargetNonCompletto = false;
    this.msgControlloTarget = 'Errore non gestito';

    if (
      esito.content.some(
        (elem: any) =>
          elem.idTargetQualitativi.length === 0 && elem.idTargetQuantitativi.length === 0,
      )
    ) {
      this.isTargetNonCompletto = true;
      this.msgControlloTarget = 'Selezionare almeno un target Qualitativo o Quantitativo';
    } else {
      // Controllo che i obiettivi nascosti dal paginator siano compilati
      const idPianoSostenibilita = this.formPianoSostenibilita.get('id')?.value;
      if (idPianoSostenibilita && esito.content.length != esito.totalElements) {
        this.pianoService.getControlloTargetPaginati(idPianoSostenibilita).subscribe({
          next: (esito) => {},
          error: (err) => {
            this.isTargetNonCompletto = true;
            this.msgControlloTarget = 'Obiettivi non completati, espandere la lista';
          },
        });
      }
    }
  }

  /**
   * Gestico lo stile della singola riga della tabella
   * @param record riga
   * @returns style
   */
  public fnCaricamentoStyleTargetRed: FnCaricamentoStyle = (record: any) => {
    const colore =
      record?.idTargetQualitativi.length === 0 && record?.idTargetQuantitativi.length === 0
        ? '#D90000'
        : 'black';

    return {
      color: colore,
      fontWeight: '500',
    };
  };
  public fnCaricamentoStyleTargetBlack: FnCaricamentoStyle = (record: any) => {
    return {
      color: 'black',
      fontWeight: '500',
    };
  };

  public fnCaricamentoDatiTarget: FnCaricamentoDati = (
    page: number,
    pageSize: number,
    ricerca?: string,
    filters?: Filters[],
    sortBy?: SortBy[],
  ) => {
    const idPianoSostenibilita = this.formPianoSostenibilita.get('id')?.value;

    if (idPianoSostenibilita) {
      // Se sorto per tematica, cambio la chiave.
      sortBy?.forEach((sort) => {
        switch (sort.chiave) {
          case 'titoloTematica':
            sort.chiave = 'posizioneTematica';
            break;
          case 'titoloAmbito':
            sort.chiave = 'ordAmbito';
            break;
        }
      });

      return this._caricaObiettivi(idPianoSostenibilita, page, pageSize, ricerca, filters, sortBy);
    } else {
      return of(false);
    }
  };

  private _caricaObiettivi(
    idPianoSostenibilita: string,
    page: number,
    pageSize: number,
    ricerca?: string,
    filters?: Filters[],
    sortBy?: SortBy[],
  ) {
    return this.pianoService
      .getObiettiviTarget(idPianoSostenibilita, page, pageSize, ricerca, filters, sortBy)
      .pipe(
        map((esito) => {
          if (!this.isPubblicato() && !this.isArchiviato()) {
            this.ctrAssegnazioniTarget(esito);
          }

          return esito;
        }),
      );
  }

  public fnCaricamentoDatiCruscotto: FnCaricamentoDati = (
    page: number,
    pageSize: number,
    ricerca?: string,
    filters?: Filters[],
    sortBy?: SortBy[],
  ) => {
    const idPianoSostenibilita = this.formPianoSostenibilita.get('id')?.value;

    if (idPianoSostenibilita) {
      return this.pianoService.getCruscotti(
        idPianoSostenibilita,
        page,
        pageSize,
        ricerca,
        filters,
        sortBy,
      );
    } else {
      return of(false);
    }
  };

  async caricaStepCruscotto() {
    this.spinnerOver.show();
    this.tabellaCruscotto.caricaDati();
    this.spinnerOver.hide();

    const idPianoSostenibilita = this.formPianoSostenibilita.get('id')?.value;
    if (idPianoSostenibilita) {
      return await this.cmpTotaliCruscotto.getTotaliCruscotto();
    } else {
      return true;
    }
  }

  caricaDocumento() {
    const idPianoSostenibilita = this.formPianoSostenibilita.get('id')?.value;
    this.spinnerOver.show();
    if (idPianoSostenibilita) {
      this.pianoService.getDocumento(idPianoSostenibilita).subscribe({
        next: (esito) => {
          this.objDocumento = esito;
          this.spinnerOver.hide();
        },
        error: (err) => {
          console.error(err);
          this.spinnerOver.hide();
        },
      });
    }
  }

  //******************************* METODI SALVATAGGIO PER avanti() *************************************/

  /**
   * Metodo salvataggio STEP 1 Piano
   * @returns
   */
  private async _salvaStepPiano() {
    const idPiano = this.formPianoSostenibilita.get('id')?.value;

    if (idPiano) {
      return true;
    }

    if (this.formPianoSostenibilita.valid) {
      const dialog = this.utilityService.openDialog({
        titolo: 'Avviso',
        descrizione: 'Continuando non sarà più possibile modificare queste informazioni.',
        bottoni: [
          {
            nome_btn: 'Annulla',
            id_btn: 'N',
          },
          {
            nome_btn: 'Avanti',
            id_btn: 'S',
          },
        ],
      });

      const valDialog = await firstValueFrom(dialog.beforeClosed());
      if (valDialog === 'N') {
        return false;
      }
    }

    if (this.formPianoSostenibilita.valid) {
      this.spinnerOver.show();

      let formCrtSostenibilita = this.formPianoSostenibilita.getRawValue();

      const nuovaPiano = {
        ...formCrtSostenibilita,
        idMaterialita: this.inclusioneModuli.formInclusioneModuli
          .get('idMaterialita')
          ?.getRawValue()?.id,
        idSintesiSostenibilita: this.inclusioneModuli.formInclusioneModuli
          .get('idSintesiSostenibilita')
          ?.getRawValue()?.id,
        idAutovalutazioneCompilata: this.inclusioneModuli.formInclusioneModuli
          .get('idAutovalutazioneCompilata')
          ?.getRawValue()?.id,
        idPolicySostenibilita: this.inclusioneModuli.formInclusioneModuli
          .get('idPolicySostenibilita')
          ?.getRawValue()?.id,
        idBilancioSostenibilita: this.inclusioneModuli.formInclusioneModuli
          .get('idBilancioSostenibilita')
          ?.getRawValue()?.id,
      };

      return firstValueFrom(
        this.pianoService.postCreazionePianoStep1(nuovaPiano).pipe(
          map((esito) => {
            this.formPianoSostenibilita.get('id')?.setValue(esito.id);

            this.formPianoSostenibilita.disable();

            return true;
          }),
          catchError((err) => {
            this.utilityService.openDialog({
              titolo: 'Attenzione',
              descrizione: err.error.message,
              bottoni: [{ nome_btn: 'Ok' }],
            });
            this.spinnerOver.hide();

            return of(false);
          }),
        ),
      );
    } else {
      Object.values(this.formPianoSostenibilita.controls).forEach((control) => {
        control.markAsTouched();
      });
      return false;
    }
  }

  /**
   * Metodo salvataggio STEP  TEMATICHE
   * @returns
   */
  private async _salvaStepTematiche() {
    if (
      this.componenteSurvey.stato === 'PUBBLICATO' ||
      this.componenteSurvey.stato === 'ARCHIVIATO'
    ) {
      return true;
    } else {
      return firstValueFrom(
        this.componenteSurvey.salva().pipe(
          map((esito) => {
            if (esito) {
              return true;
            } else {
              return false;
            }
          }),
          catchError((error) => {
            console.error('ERRORE SALVATAGGIO COMPONENTE SURVEY: ', error);
            return of(false);
          }),
        ),
      );
    }
  }

  /**
   * Metodo salvataggio STEP 6 Obiettivi
   * @returns
   */
  private async _salvaStepObiettivi() {
    if (this.componenteSurvey.stato === 'PUBBLICATO') {
      return true;
    } else {
      return firstValueFrom(
        this.componenteSelObiettiviPiano.salva().pipe(
          map((esito) => {
            if (esito) {
              return true;
            } else {
              return false;
            }
          }),
          catchError((err) => {
            console.error('ERRORE SALVATAGGIO OBIETTIVI : ', err);
            return of(false);
          }),
        ),
      );
    }
  }

  private _ctrTarget() {
    if (this.isTargetNonCompletto) {
      this.tabellaTarget.fnCaricamentoStyle = this.fnCaricamentoStyleTargetRed;
      this.tabellaTarget.updateStyle();

      this.utilityService.openSnackBar(this.msgControlloTarget, '', {
        duration: 2000,
        panelClass: ['red-snackbar'],
      });

      return false;
    } else {
      return true;
    }
  }

  /**
   * STAMPA DOCUMENTO
   */
  async stampa() {
    const idPiano = this.formPianoSostenibilita.get('id')?.value;

    try {
      if (idPiano) {
        this.spinnerOver.show();
        await this.cmpTotaliCruscotto.getTotaliCruscotto();
        this.spinnerOver.hide();

        if (this.cmpTotaliCruscotto.isElementiNonCompilati(['KPI', 'AZIONI'])) {
          let titolo: string = 'Stampa';
          let descrizione: string = `
          <div>
            <p>
              Non sono state <strong>completate</strong> tutte le <strong>compilazioni</strong>.
            </p>
            <p><strong>Vuoi procedere?</strong></p>
          </div>`;

          const dialog = this.utilityService.openDialog({
            titolo: titolo,
            descrizione: descrizione,
            fontWeight: '500',
            bottoni: [
              { nome_btn: 'No', id_btn: 'N' },
              { nome_btn: 'Si', id_btn: 'S' },
            ],
          });

          const valDialog = await firstValueFrom(dialog.beforeClosed());
          if (valDialog === 'N') {
            return Promise.resolve(false);
          }
        }

        await firstValueFrom(this.salvaDocumento());

        this.spinnerOver.show();

        return firstValueFrom(
          this.pianoService.postStampaPiano(idPiano).pipe(
            map((urlStampa) => {
              window.open(urlStampa?.body, '_blank');

              return false;
            }),
            catchError((err) => {
              console.error(err);

              this.utilityService.openDialog({
                titolo: 'Attenzione',
                descrizione: 'Stampa non riuscita. Verificare le configurazioni e riprovare.',
                bottoni: [{ nome_btn: 'Ok' }],
              });

              return of(false);
            }),
            finalize(() => {
              this.spinnerOver.hide();
            }),
          ),
        );
      } else {
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  salvaDocumentoInHTML() {
    this.salvaDocumento().subscribe();
  }

  /**
   * SALVA DOCUMENTO
   * @param idPiano
   * @returns
   */
  salvaDocumento(): Observable<any> {
    const idPiano = this.formPianoSostenibilita.get('id')?.value;
    if (idPiano) {
      this.spinnerOver.show();
      return this.pianoService.putDocumento(idPiano, this.objDocumento).pipe(
        map((response) => {}),
        catchError((err) => {
          console.error(err);
          return of({ error: true, message: 'Errore nel salvataggio del documento' });
        }),
        tap({
          finalize: () => this.spinnerOver.hide(),
        }),
      );
    } else {
      return of();
    }
  }

  /**
   * Metodo che mi crea / modifica Obiettivo aziendale
   * @param obiettivoAziendale
   */
  async modificaObiettivoAziendale(obiettivoAziendale?: any) {
    try {
      if (!this.isPermessoSoloRead) {
        await firstValueFrom(this.salvaDocumento());
      }

      const dialogModificaElemento = this.dialog.open(DialogCreaObiettivoAziendaliComponent, {
        data: {
          obiettivoAziendalePiano: obiettivoAziendale,
          idContest: this.formPianoSostenibilita.get('id')?.value,
          isPermessoSoloRead: this.isPermessoSoloRead,
        },
        panelClass: 'dialog-container',
        disableClose: true,
        width: '70%',
        maxHeight: '95%',
        autoFocus: false,
      });

      dialogModificaElemento.afterClosed().subscribe((esito: any) => {
        if (esito) {
          this.caricaDocumento();
        }
      });
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * Metodo che mi crea / modifica modello di sviluppo
   * @param modelloSviluppo
   */
  async modificaModelloSviluppo(modelloSviluppo?: any) {
    try {
      if (!this.isPermessoSoloRead) {
        await firstValueFrom(this.salvaDocumento());
      }

      const dialogModificaElemento = this.dialog.open(DialogCreaCfgModelliSviluppoPianoComponent, {
        data: {
          modelloSviluppoPiano: modelloSviluppo,
          idContest: this.formPianoSostenibilita.get('id')?.value,
        },
        panelClass: 'dialog-container',
        disableClose: true,
        width: '70%',
        maxHeight: '95%',
        autoFocus: false,
      });

      dialogModificaElemento.afterClosed().subscribe((esito: any) => {
        if (esito) {
          this.caricaDocumento();
        }
      });
    } catch (error) {
      console.error(error);
    }
  }

  ctrAnnoPianoUtilizzata(anno: string) {
    return this.isAnnoSettoreValid(anno, this.formPianoSostenibilita.get('settori')?.value?.id);
  }

  ctrSettorePianoUtilizzata(settore: Settore) {
    const anno = this.formPianoSostenibilita.get('anno')?.value;
    return this.isAnnoSettoreValid(anno, settore?.id);
  }

  /**
   * Controlli degli stepper
   * @param stepperDaControllare
   * @returns
   */
  private async ritornoControllo(stepperDaControllare: number): Promise<boolean> {
    let isCtrFallito: boolean = false;
    switch (stepperDaControllare) {
      case 1:
        isCtrFallito = this.componenteSurvey.ctrSalva();
        break;

      case 2: {
        const esito = await this._getObiettiviPiano();
        if (esito) {
          isCtrFallito = this.componenteSelObiettiviPiano.ctrStepper('obiettivo');
        }
        break;
      }
      case 3: {
        const idPianoSostenibilita = this.formPianoSostenibilita.get('id')?.value;

        if (idPianoSostenibilita) {
          const esito = await firstValueFrom(
            this._caricaObiettivi(idPianoSostenibilita, 0, 9999999),
          );

          if (esito) {
            isCtrFallito = !this._ctrTarget();
          }
        }

        break;
      }
      case 4: {
        const esito = await this.caricaStepCruscotto();
        if (esito) {
          isCtrFallito = this.componenteSelObiettiviPiano.ctrStepper('impegno');
        }
        break;
      }

      default:
        break;
    }
    return isCtrFallito;
  }

  /**
   * gestione controlli step selezionati
   * @param stepperSelezionato
   * @returns
   */
  private async ctrStep(stepperSelezionato: number): Promise<number> {
    const stepperCorrente = this.stepper.selectedIndex;

    if (stepperSelezionato > stepperCorrente) {
      for (let index = stepperCorrente; index < stepperSelezionato; index++) {
        // Salvo step corrente
        if (stepperCorrente === index) {
          const isSalvato = await this.avanti();
          if (!isSalvato) {
            return stepperCorrente;
          } else {
            continue;
          }
        }

        // Controllo step by step e ritorno l'index dove da errore
        if (await this.ritornoControllo(index)) {
          return index;
        }
      }
    }

    return stepperSelezionato;
  }

  /**
   * Metodo getione stepper piano
   */
  gestioneStepperPiano() {
    setTimeout(() => {
      this.stepper.steps.forEach((step, idx) => {
        step.select = () => {
          this.handleStepSelect(idx);
        };
      });
    }, 0);
  }

  /**
   * Logica di spostamento sugli stepper
   */
  private async handleStepSelect(idx: number): Promise<void> {
    if (this.saltaCtrStepper(idx)) {
      this.stepper.selectedIndex = idx;
      return;
    }
    /* Se step selezionato è completed devo controllare gli step in mezzo
           Esempio (sono su STEP 1 seleziono STEP 6 , devo controllare STEP 2-3-4-5) */
    if (this.stepper.steps.get(idx)?.completed) {
      this.stepper.selectedIndex = await this.ctrStep(idx);
      return;
    }
    // linear
    if (idx === this.stepper.selectedIndex + 1) {
      const isSalvato = await this.avanti();
      if (isSalvato) {
        this.stepper.selectedIndex = idx;
      }
    }
  }

  saltaCtrStepper(idx: number) {
    // Se i miei permessi sono solo in read
    if (this.isPermessoSoloRead) {
      return true;
    }

    // Se pubblicato
    if (this.isPubblicato() || this.isArchiviato()) {
      return true;
    }

    // Se torno indietro non faccio ne controlli ne salvataggi
    if (idx < this.stepper.selectedIndex) {
      return true;
    }

    return false;
  }

  /**
   * Questionario pubblicato
   * @returns true === PUBBLICATO
   */
  public isPubblicato(): boolean {
    return this._piano?.stato === 'PUBBLICATO' || this.data?.piano?.stato === 'PUBBLICATO';
  }
  public isArchiviato(): boolean {
    return this._piano?.stato === 'ARCHIVIATO' || this.data?.piano?.stato === 'ARCHIVIATO';
  }

  /**
   * Viene richiamato nel momento in cui si caricano le tamatiche (questionario)
   */
  public completaStep() {
    if (this.isPubblicato() || this.isArchiviato()) {
      this.stepper.steps.forEach((step, idx) => {
        step.completed = true;
      });
    }
  }

  private isAnnoSettoreValid(anno: string | undefined, settoreId: string | undefined) {
    return anno && settoreId && this.mappaAnnoSettore[anno]?.[settoreId];
  }
}
